import config from "../config";

export const CUSTOMER_PORTAL_LOCKOUT_HOUR_OPTIONS = [12, 24, 48, 72];

export const CUSTOMER_PORTAL_SETTING_DEFAULTS = {
  module_enabled: false,
  allow_client_edit: true,
  allow_client_cancel: true,
  allow_client_reschedule: true,
  waitlist_enabled: true,
  social_login_enabled: false,
  client_change_lockout_enabled: false,
  client_change_lockout_hours: 24,
};

const BOOLEAN_SETTING_KEYS = [
  "module_enabled",
  "allow_client_edit",
  "allow_client_cancel",
  "allow_client_reschedule",
  "waitlist_enabled",
  "social_login_enabled",
  "client_change_lockout_enabled",
];

function coercePortalSettingValue(value, defaultEnabled = true) {
  if (value === false || value === 0 || value === "0" || value === "false") {
    return false;
  }

  if (value === true || value === 1 || value === "1" || value === "true") {
    return true;
  }

  return defaultEnabled;
}

function normalizeLockoutHours(value) {
  const hours = Number(value);
  return CUSTOMER_PORTAL_LOCKOUT_HOUR_OPTIONS.includes(hours) ? hours : CUSTOMER_PORTAL_SETTING_DEFAULTS.client_change_lockout_hours;
}

export const getCustomerPortalSettings = (settings) => {
  let parsed = settings;

  if (typeof settings === "string") {
    try {
      parsed = JSON.parse(settings);
    } catch (error) {
      parsed = {};
    }
  }

  const merged = {
    ...CUSTOMER_PORTAL_SETTING_DEFAULTS,
    ...(parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {}),
  };

  const normalized = {};

  BOOLEAN_SETTING_KEYS.forEach((key) => {
    normalized[key] = coercePortalSettingValue(merged[key], CUSTOMER_PORTAL_SETTING_DEFAULTS[key]);
  });

  normalized.client_change_lockout_hours = normalizeLockoutHours(merged.client_change_lockout_hours);

  return normalized;
};

export const isCustomerPortalSettingEnabled = (settings, key) => {
  const normalized = getCustomerPortalSettings(settings);
  if (key === "waitlist_enabled" && !normalized.module_enabled) {
    return false;
  }
  return normalized[key] === true;
};

export const isCustomerPortalModuleEnabled = (settings) => {
  return isCustomerPortalSettingEnabled(settings, "module_enabled");
};

const normalizePublicUrl = (url) => {
  const trimmed = String(url || "").trim().replace(/\/+$/, "");
  if (!trimmed) {
    return "";
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return `http://${trimmed}`;
};

export const isCustomerPortalEnvConfigured = () => {
  return Boolean(config.rootAppConfigured) && Boolean(config.customerUrlConfigured);
};

export const getCustomerPortalPageHref = (page) => {
  if (!isCustomerPortalEnvConfigured()) {
    return null;
  }

  const standalonePath = page === "login" ? "/login" : "/dashboard";
  const embeddedPath = page === "login" ? "/customer-portal/login" : "/customer-portal/dashboard";
  const customerUrl = normalizePublicUrl(config.customerPortalPublicUrl);
  const rootApp = (config.rootApp || "").toLowerCase();

  if (rootApp === "main") {
    return customerUrl ? `${customerUrl}${standalonePath}` : null;
  }

  if (rootApp === "customer" || rootApp === "both") {
    try {
      const target = new URL(customerUrl);
      if (typeof window !== "undefined" && target.host && target.host !== window.location.host) {
        return `${customerUrl}${standalonePath}`;
      }
    } catch (error) {
      /* use embedded routes when customer URL is not a full origin */
    }
    return embeddedPath;
  }

  return null;
};

export const getCustomerPortalLoginPath = () => getCustomerPortalPageHref("login");

export const getCustomerPortalDashboardPath = () => getCustomerPortalPageHref("dashboard");

export const goToCustomerPortalPage = (page, navigate, options = {}) => {
  const href = getCustomerPortalPageHref(page);
  if (!href) {
    return false;
  }

  if (/^https?:\/\//i.test(href)) {
    window.location.assign(href);
    return true;
  }

  if (typeof navigate === "function") {
    navigate(href, {
      replace: options.replace !== false,
      state: options.state,
    });
    return true;
  }

  window.location.assign(href);
  return true;
};
